import { call, put, select } from "redux-saga/effects";
import { UPDATE_AUTH } from "../constant";
import { refreshAuthCredits } from "../utils/accountActivity";
import { getAuthToken, getAuthUserId } from "../utils/userIdentity";

function dispatchCreditsToClientStore(payload) {
  try {
    // Dealers navbar mounts Credits & evaluations against the main client store.
    // eslint-disable-next-line global-require
    const clientStore = require("../store").default;
    if (clientStore?.store?.dispatch && Object.keys(payload).length) {
      clientStore.store.dispatch({ type: UPDATE_AUTH, payload });
    }
  } catch {
    // Ignore if store is unavailable.
  }
}

/**
 * After evaluation / address / appointment (and similar) success, pull the
 * latest credit balance and last evaluation date into auth so the Credits &
 * evaluations popup updates.
 */
export function* syncCreditsAfterCharge() {
  try {
    const auth = yield select((state) => state.auth);
    const userId = getAuthUserId(auth);
    const token = getAuthToken(auth);
    if (!userId || !token) return;

    const result = yield call(refreshAuthCredits, { userId, token });
    if (!result) return;

    const payload = {};
    if (result.credits != null) payload.credits = result.credits;
    if (result.lastEvaluation) payload.last_evaluation = result.lastEvaluation;
    if (!Object.keys(payload).length) return;

    yield put({ type: UPDATE_AUTH, payload });
    dispatchCreditsToClientStore(payload);
  } catch {
    // Credit refresh must not break the primary step flow.
  }
}
